var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNurseTaskon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3478_50852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0C41.3137 0 44 2.68629 44 6V17.1553C43.9119 17.1471 43.8227 17.1426 43.7324 17.1426C42.1545 17.1426 40.875 18.422 40.875 20C40.875 21.578 42.1545 22.8574 43.7324 22.8574C43.8227 22.8574 43.9119 22.8519 44 22.8438V34C44 37.3137 41.3137 40 38 40H10C6.68629 40 4 37.3137 4 34V6C4 2.68629 6.68629 1.28851e-07 10 0H38Z",
    fill: "#04B7B1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0202 34.2413C27.7728 34.515 27.3673 34.515 27.1199 34.2433L21.5049 27.9895C21.2555 27.7158 21.2656 27.2778 21.5272 27.0182L22.4904 26.053C22.752 25.7934 23.1758 25.7954 23.4313 26.0611L27.0915 29.845C27.349 30.1106 27.7647 30.1045 28.0121 29.8308L34.9553 22.2224C35.2048 21.9507 35.6326 21.9284 35.9084 22.1778L36.7601 22.847C37.6888 23.7757 37.7618 23.8731 36.7601 24.8748L28.0202 34.2413Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.51 9.77148C21.4961 9.77148 21.4961 11.7993 21.4961 11.7993H23.5239C23.5239 11.7993 23.5239 9.77148 22.51 9.77148Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6374 9.77046H27.5818C27.4074 7.74265 25.554 5.71484 22.5123 5.71484C19.4706 5.71484 17.6172 7.74265 17.4428 9.77046H13.3872C13.3872 9.77046 11.3594 9.77046 11.3594 11.7983C11.3594 13.4509 11.3594 30.0485 11.3594 32.0763C11.3594 34.1041 13.3872 34.1041 13.3872 34.1041H24.7997L19.7302 29.065C18.8785 28.1302 19.3429 26.9318 20.2371 26.0396L21.758 24.5248C22.198 24.0848 22.6583 24.0219 23.2788 24.0219C23.9054 24.0219 24.8707 24.5876 25.3066 25.0398L27.6285 27.5746L33.6653 21.0674C33.6653 21.0674 33.6653 13.8261 33.6653 11.7983C33.6653 9.77046 31.6374 9.77046 31.6374 9.77046ZM16.4289 21.9373H15.415C15.415 21.9373 14.4011 21.9373 14.4011 20.9234C14.4011 19.9095 15.415 19.9095 15.415 19.9095H16.4289C16.4289 19.9095 17.4428 19.9095 17.4428 20.9234C17.4428 21.9373 16.4289 21.9373 16.4289 21.9373ZM16.4289 17.8817H15.415C15.415 17.8817 14.4011 17.8817 14.4011 16.8678C14.4011 15.8539 15.415 15.8539 15.415 15.8539H16.4289C16.4289 15.8539 17.4428 15.8539 17.4428 16.8678C17.4428 17.8817 16.4289 17.8817 16.4289 17.8817ZM29.6096 21.9373H20.4845C20.4845 21.9373 19.4706 21.9373 19.4706 20.9234C19.4706 19.9095 20.4845 19.9095 20.4845 19.9095H29.6096C29.6096 19.9095 30.6235 19.9095 30.6235 20.9234C30.6235 21.9373 29.6096 21.9373 29.6096 21.9373ZM29.6096 17.8817H20.4845C20.4845 17.8817 19.4706 17.8817 19.4706 16.8678C19.4706 15.8539 20.4845 15.8539 20.4845 15.8539H29.6096C29.6096 15.8539 30.6235 15.8539 30.6235 16.8678C30.6235 17.8817 29.6096 17.8817 29.6096 17.8817ZM13.3872 13.8261C13.3872 13.8261 13.3872 11.7983 15.415 11.7983C17.4428 11.7983 19.4706 11.7983 19.4706 11.7983C19.4706 11.7983 19.4706 7.86838 22.5123 7.86838C25.554 7.86838 25.6088 11.7983 25.554 11.7983C25.554 11.7983 27.5818 11.7983 29.6096 11.7983C31.6374 11.7983 31.6374 13.8261 31.6374 13.8261H13.3872Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3478_50852",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3478_50852"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3478_50852",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurseTaskon);
export default __webpack_public_path__ + "static/media/NurseTaskon.ee60443f274680e6d7f8c98f6d16518a.svg";
export { ForwardRef as ReactComponent };